var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_b_4137:82268)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#2B2B2B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.536 15.466C23.0004 15.9303 23.3688 16.4815 23.6202 17.0882C23.8716 17.695 24.0009 18.3452 24.0009 19.002C24.0009 19.6587 23.8716 20.309 23.6202 20.9157C23.3688 21.5224 23.0004 22.0736 22.536 22.538M25.364 12.638C26.1997 13.4737 26.8627 14.4658 27.315 15.5578C27.7673 16.6497 28.0001 17.8201 28.0001 19.002C28.0001 20.1839 27.7673 21.3542 27.315 22.4461C26.8627 23.5381 26.1997 24.5302 25.364 25.366M11 22.002C10.7348 22.002 10.4804 21.8966 10.2929 21.7091C10.1054 21.5215 10 21.2672 10 21.002V17.002C10 16.7367 10.1054 16.4824 10.2929 16.2949C10.4804 16.1073 10.7348 16.002 11 16.002H12.586L17.293 11.295C17.923 10.665 19 11.111 19 12.002V22.538V26.002C19 26.893 17.923 27.339 17.293 26.709L14.5 24.002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4137:82268",
    x: -4,
    y: -4,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4137:82268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4137:82268",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound-on.4b1e4854c3771ae276abc8a5e4608f80.svg";
export { ForwardRef as ReactComponent };